import React from 'react';

class ReceptorSelected extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <div>
        {data.razon_social}
        <br />

        <div className="pt-2">
          <span>RFC: </span>
          {data.rfc}
          <br />

          <span>Uso CFDI: </span>
          {data.uso_cfdi}
          <br />

          <span>Régimen: </span>
          {data.regimen}
          <br />

          <span>CP: </span>
          {data.cp || data.direccion?.cp}
          <br />

          <span>Email: </span>
          {data.email}
          <br />

          {data?.sector_primario_is_adquiriente && (
            <>
              <br />
              <span className="badge badge-primary">adquiriente</span>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default ReceptorSelected;
